import script from "./QModalVideos.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalVideos.vue?vue&type=script&setup=true&lang=js"

import "./QModalVideos.vue?vue&type=style&index=0&id=1e04c738&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e04c738"]])

export default __exports__